/*
  ============================================================
  FILE: ctx-popup-outside-close.js
  LOCATION: assets/ctx-popup-outside-close.js

  Click anywhere off a popup and it closes. One file for the whole site, rather
  than the same three lines pasted into a dozen sections and forgotten in half.

  WHY IT WORKS THIS WAY

  It never hides anything itself - it finds the popup's own close control and
  clicks it. Every popup here has teardown to do on close: putting the shipping
  calculator back where it came from, unloading a video so it stops playing,
  releasing the scroll lock, unpinning from the visual viewport. Hiding the element
  directly would skip all of that and leave audio playing behind a closed popup.

  THE OPENING-CLICK TRAP

  A single click both opens a popup and, a moment later, arrives at the document.
  Handled naively, a popup opens and shuts in the same click. So the set of open
  popups is captured on mousedown - before anything opens - and only those are
  candidates for closing. A popup that was not open when the mouse went down
  cannot be closed by the click that opened it.

  ADDING A POPUP: add a row to POPUPS. Root is the outermost element, panel is the
  part that must stay open when clicked, close is the button to press.
  ============================================================
*/
(function () {
  'use strict';

  var POPUPS = [
    /* Product page */
    { root: '.cp-step-modal', panel: '.cp-step-modal__panel', close: '.cp-step-modal__close' },
    { root: '.cp-spec-modal', panel: '.cp-spec-modal__panel', close: '.cp-spec-modal__close' },
    { root: '.cp-ship-modal', panel: '.cp-ship-modal__panel', close: '.cp-ship-modal__close' },
    { root: '.cp-lightbox',   panel: '.cp-lightbox__dialog',  close: '.cp-lightbox__close' },

    /* Facility quote form - the confirmation popup had no way out but the X */
    { root: '[class*="eq-overlay-"]', panel: '[class*="eq-modal-box-"]', close: '[class*="eq-modal-x-"]' },

    /* "Who we buy from" video */
    { root: '[role="dialog"]', panel: '.wbf-modal-inner', close: '.wbf-modal-close' }

    /* Deliberately absent: the delivery section's video is not a popup. It plays in
       place of its own thumbnail inside the card, so there is no "outside" to click -
       treating it as a popup would stop playback on the first click anywhere. */
  ];

  /* Visible on screen right now, not merely present in the DOM. Several of these
     popups live in the page permanently and are switched with [hidden] or a class,
     so presence proves nothing. */
  function isOpen(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function openPopups() {
    var found = [];
    POPUPS.forEach(function (def) {
      var roots;
      try { roots = document.querySelectorAll(def.root); } catch (err) { return; }
      roots.forEach(function (el) {
        /* A [role="dialog"] rule is deliberately broad, so require the panel this
           row names to actually be inside - that is what proves it is the popup
           the row was written for and not somebody else's dialog. */
        if (!el.querySelector(def.panel)) return;
        if (!isOpen(el)) return;
        found.push({ el: el, def: def });
      });
    });
    return found;
  }

  var openAtMouseDown = [];

  document.addEventListener('mousedown', function () {
    openAtMouseDown = openPopups();
  }, true);

  /* Touch screens do not fire mousedown before click on every browser. */
  document.addEventListener('touchstart', function () {
    openAtMouseDown = openPopups();
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    if (!openAtMouseDown.length) return;
    var snapshot = openAtMouseDown;
    openAtMouseDown = [];

    snapshot.forEach(function (item) {
      var el = item.el;
      if (!isOpen(el)) return;                      /* already closed by its own handler */
      if (e.target.closest(item.def.panel)) return; /* clicked inside - leave it alone */

      /* Some popups keep their dimmed backdrop as a sibling rather than a child, so a
         click landing outside the root element still counts as an outside click. What
         matters is only that it was not inside the panel. */
      var closeBtn = el.querySelector(item.def.close);
      if (closeBtn) { closeBtn.click(); return; }

      /* No close control found: hide it rather than trap the customer. */
      el.setAttribute('hidden', '');
    });
  });
})();
